export default [
  {
    path: '/exam',
    name: 'exam',
    meta: {
      title: '考试',
    },
    component: () => import('@views/exam/index'),
  },
  {
    path: '/mockexams',
    name: 'mockexams',
    meta: {
      title: '模拟考试',
    },
    component: () => import('@views/exam/mockExams'),
  },
  {
    path: '/mockexams/startmock',
    name: 'mockexamsStart',
    meta: {
      title: '开始模拟考试',
    },
    component: () => import('@views/exam/mockExams/startMockExam'),
  },
  {
    path: 'questionbank',
    component: () => import('@views/exam/questionbank'),
    meta: {
      title: '题库',
      to: '/questionbank',
      noPadding: true,
    },
  },
  {
    path: '/questionbank/questionSheetView',
    name: 'questionSheetView',
    meta: {
      title: '题单题目预览',
      noPadding: true,
    },
    component: () => import('@views/exam/questionbank/questionSheetView'),
  },
  {
    path: '/questionbank/answerRecord',
    name: 'answerRecord',
    meta: {
      title: '答题记录',
      noPadding: true,
    },
    component: () => import('@views/exam/questionbank/answerRecord'),
  },
  {
    path: '/questionbank/topicViewDetails',
    name: 'topicViewDetails',
    meta: {
      title: '题目详情',
      noPadding: true,
    },
    component: () => import('@views/exam/questionbank/topicViewDetails'),
  },
  {
    path: '/questionbank/ojAnswer',
    name: 'ojAnswer',
    meta: {
      title: 'oj答题',
      noPadding: true,
      isHiddenFooter: true,
    },
    component: () => import('@views/exam/questionbank/ojAnswer'),
  },
  {
    path: '/questionbank/topicAnswerDetails',
    name: 'topicAnswerDetails',
    meta: {
      title: '提交答案',
      noPadding: true,
    },
    component: () => import('@views/exam/questionbank/topicAnswerDetails'),
  },
  {
    path: 'detail',
    component: () => import('@views/exam/detail'),
    meta: {
      title: '我的考试',
      to: '/exam',
    },
    children: [
      {
        path: 'bandTestDetail',
        name: 'exam/bandTestDetail',
        meta: {},
        component: () => import('@views/exam/detail/bandTest'),
      },
      {
        path: 'examPay',
        name: 'exam/examPay',
        meta: {},
        component: () => import('@views/exam/examPay'),
      },
      {
        path: 'customTestDetail',
        name: 'exam/customTestDetail',
        meta: {},
        component: () => import('@views/exam/detail/customTest'),
      },
      {
        path: 'selfTestDetail',
        name: 'exam/selfTestDetail',
        meta: {},
        component: () => import('@views/exam/detail/selfTest'),
      },
      {
        path: 'stemaTestDetail',
        name: 'exam/stemaTestDetail',
        meta: {},
        component: () => import('@views/exam/detail/stemaTest'),
      },
      {
        path: 'bandtestBlockDetail',
        name: 'exam/bandtestBlockDetail',
        meta: {},
        component: () => import('@views/exam/detail/bandTestBlock'),
      },
    ],
  },
];
